<template>
  <BulgogiBody />
</template>

<script>
import BulgogiBody from '../molecules/BulgogiBody.vue'


export default {
  name: 'BulgogiView',
  components: {
    BulgogiBody,
  }
}
</script>
